import { render, staticRenderFns } from "./comTab.vue?vue&type=template&id=1f9904ea&"
import script from "./comTab.vue?vue&type=script&lang=js&"
export * from "./comTab.vue?vue&type=script&lang=js&"
import style0 from "./comTab.vue?vue&type=style&index=0&id=1f9904ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports